import { ReleasesApiProvider } from "@urbanx/agx.releases.client";
import AppConfig from "config/AppConfig";
import { type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const ApiProvider = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReleasesApiProvider appConfig={AppConfig}>
        {children}
      </ReleasesApiProvider>
    </QueryClientProvider>
  );
};

export default ApiProvider;
